"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _formValidation = _interopRequireDefault(require("./formValidation"));
var _meterReading = _interopRequireDefault(require("./meterReading"));
var _contracts = _interopRequireDefault(require("./contracts"));
var _personalData = _interopRequireDefault(require("./personalData"));
var _loggedinMeterReading = _interopRequireDefault(require("./loggedinMeterReading"));
var _invoice = _interopRequireDefault(require("./invoice"));
var _accountData = _interopRequireDefault(require("../../common/features/AccountData/redux/accountData"));
var _registrationReducer = _interopRequireDefault(require("../../common/features/Registration/registrationReducer"));
var _devices = _interopRequireDefault(require("./devices"));
var _budgetBillingPlan = _interopRequireDefault(require("./budgetBillingPlan"));
var _search = _interopRequireDefault(require("./search"));
var _meterPins = _interopRequireDefault(require("./meterPins"));
var _rlm = _interopRequireDefault(require("./rlm"));
var _contactLoggedIn = _interopRequireDefault(require("./contactLoggedIn"));
var _mastr = _interopRequireDefault(require("./mastr"));
var _consumptionSubscription = _interopRequireDefault(require("./consumptionSubscription"));
var _regulations = _interopRequireDefault(require("./regulations"));
var _directMark = _interopRequireDefault(require("./directMark"));
var _communication = _interopRequireDefault(require("./communication"));
var _phone = _interopRequireDefault(require("../../cic/redux/phone"));
var _myAppointment = _interopRequireDefault(require("../../cic/redux/myAppointment"));
var _postboxReducer = _interopRequireDefault(require("../../common/features/PostBox/redux/postboxReducer"));
var _companiesInTrouble = _interopRequireDefault(require("../../common/features/CompaniesInTrouble/redux/companiesInTrouble"));
var reducers = {
  formValidation: _formValidation.default,
  meterReading: _meterReading.default,
  myData: _personalData.default,
  contracts: _contracts.default,
  loggedInMeterReading: _loggedinMeterReading.default,
  invoice: _invoice.default,
  accountData: _accountData.default,
  registration: _registrationReducer.default,
  devices: _devices.default,
  budgetbillingplans: _budgetBillingPlan.default,
  meterPins: _meterPins.default,
  rlm: _rlm.default,
  contact: _contactLoggedIn.default,
  mastr: _mastr.default,
  companiesInTrouble: _companiesInTrouble.default,
  consumptionSubscription: _consumptionSubscription.default,
  regulations: _regulations.default,
  directMark: _directMark.default,
  communication: _communication.default,
  phone: _phone.default,
  myAppointment: _myAppointment.default,
  search: _search.default,
  postbox: _postboxReducer.default
};
var _default = exports.default = reducers;